import { CRM } from "@/components/atomic-crm/root/CRM";
import {
  authProvider,
  createZinspectorDataProvider,
  ZinspectorLoginPage,
} from "@/components/atomic-crm/providers/zinspector";
import { zcrmI18nProvider } from "@/components/atomic-crm/providers/zinspector/i18nProvider";
import { createZcrmStore } from "@/components/atomic-crm/providers/zinspector/zcrmStore";

/**
 * zCRM entry point: Atomic CRM on the zInspector public API (see ZCRM.md).
 * The demo (`npm run dev:demo`, demo/App.tsx) runs this same app against a fake zInspector.
 */
const dataProvider = createZinspectorDataProvider();
const store = createZcrmStore();

const App = () => (
  <CRM
    dataProvider={dataProvider}
    authProvider={authProvider}
    i18nProvider={zcrmI18nProvider}
    loginPage={ZinspectorLoginPage}
    store={store}
    disableTelemetry
  />
);

export default App;
